import React from 'react';
import { compose, is } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummary.js';
import { List, Map } from 'immutable';
import connect from 'react-redux/es/connect/connect';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import {
  PROPERTY_MANAGEMENT_GROUP,
  SERVICE_TYPE_PER_PERSON,
  SERVICE_TYPE_PER_PERSON_NIGHT
} from '../../../config/constants';
import AvailMainSideSummaryRooms from './Render/AvailMainSideSummaryRooms';
import AvailMainSideSummaryServices from './Render/AvailMainSideSummaryServices';
import AvailMainSideSummaryHotel from './Render/AvailMainSideSummaryHotel';
import AvailMainSideSummaryPenalties from './Render/AvailMainSideSummaryPenalties';
import AvailMainSideSummaryHeader from './Render/AvailMainSideSummaryHeader';
import AvailMainSideSummaryReservation from './Render/AvailMainSideSummaryReservation';
import { parseTaxes, round } from '../../../utils';
import AvailMainSideSummaryTaxes from './Render/AvailMainSideSummaryTaxes';
import AvailMainSideSummaryLoyaltyPoints from './Render/AvailMainSideSummaryLoyaltyPoints';
import AvailMainSideSummaryLoyaltyDiscount from './Render/AvailMainSideSummaryLoyaltyDiscount';
import AvailMainSideSummaryPromoCodeDiscount from './Render/AvailMainSideSummaryPromoCodeDiscount';
import AvailMainSideSummaryTotalPrice from './Render/AvailMainSideSummaryTotalPrice';
import AvailMainSideSummaryGiftCodeDiscount from './Render/AvailMainSideSummaryGiftCodeDiscount';
import AvailMainSideSummaryPay from './Render/AvailMainSideSummaryPay';
import AvailMainSideSummaryRedeemPoints from './Render/AvailMainSideSummaryRedeemPoints';
import AvailMainSideSummarySubtotalPrice from './Render/AvailMainSideSummarySubtotalPrice';
import AvailMainSideSummaryHotelInfo from './Render/AvailMainSideSummaryHotelInfo';
import { getRoomName, shouldShowTaxes } from '../../../utils';
import { getPenalties, getPenaltyTimezone, getPenaltyChargebackUSA } from '../../../utils/penalties';
import { isUsDomain } from 'synergycms_core/src/utils/utils.js';
import { applyMandatoryFeeSplit, sumTaxAmounts, getDisplayedTotalPrice, getTaxesInformationText } from './summaryPricing';
import { buildTMSPayments } from './summaryPricingTMS';

const AvailMainSideSummary = class AvailMainSideSummary extends React.Component {
  static displayName = 'AvailMainSideSummary';

  render() {
    const { config, theme } = this.props;
    let {
      hotel,
      fullVersion,
      reservationObj,
      reservationTMS,
      newCofSuccess,
      isGroup,
      isTMSRequest,
      loyaltyDiscount,
      loyaltyUser,
      loyalty,
      giftCodeDiscount,
      giftCode,
      promoCodeDiscount,
      promoCode,
      tmsTracking,
      totalAdults,
      totalChilds,
      accumulatePoints,
      penalties,
      fromPayLink,
      redeemPoints,
      summaryPriceBreakdown,
      stepCode,
      hotelInfo,
      managementGroupID,
    } = config;
    let { prepaymentAmount } = config;

    const showTaxes = shouldShowTaxes(hotel, reservationObj) ?? true;
    let totalPriceRooms = 0;
    let totalPriceServices = 0;
    const occupancies = {
      10: 0, // Adult
      8: 0 // Child
    };
    const breakdown = [];
    const parsedServices = [];
    let langCode = reservationObj && (reservationObj.getIn(['customer', 'lang'], false) || reservationObj.getIn(['language'], false) || 'en');
    if(!isTMSRequest && !tmsTracking) {
      reservationObj.get('blocks').forEach(block => {
        const roomId = block.get('room_id').toString();
        const occupGroupId = block.get('occup_group_id');
        const boardId = block.get('board_id').toString();
        const reservationRequestBlock = reservationObj.getIn(['blocks', block.get('idx') - 1]);

        const occupGroup = reservationObj.get('occup_groups').find(og => {
          return +og.get('id') === +occupGroupId;
        });

        let adults = 0;
        let childs = 0;
        const babies = null; //block.get('babies');
        const childsInfo = null; //block.get('childs_info');

        occupGroup.get('occupancies').forEach(occupancy => {
          occupancies[occupancy.get('code')] += occupancy.get('count');
          if (occupancy.get('code') === '10') {
            adults = occupancy.get('count');
          } else {
            childs = occupancy.get('count');
          }

        });

        const room = reservationObj.get('rooms').find(r => +r.get('id') === +block.get('room_id'));

        const sections = reservationObj.get('sections');

        const roomInfo = sections && (sections.find(s => s && +s.get('content_type_id') === +roomId && s.get('content_type_occup_group_id') === occupGroupId) ||
          sections.find(s => s && +s.get('content_type_id') === +roomId && s.get('content_type_occup_group_id') === room.get('default_occup_group_id')));

        const roomTranslations = roomInfo && roomInfo.getIn(['translations', langCode]);

        const needAddOccupName = (roomInfo && roomInfo.get('occup_group_id') !== reservationRequestBlock.get('occup_group_id')) || childsInfo;

        let roomOccupName =  getRoomName({ childs, adults, babies, childsInfo });

        let roomTitle;

        if (roomTranslations && !childsInfo) {
          roomTitle = roomTranslations.get('title') ? roomTranslations.get('title') : roomTranslations.get('default_title', 'room');
        } else {
          roomTitle = reservationObj
            .get('rooms')
            .find(s => +s.get('id') === +roomId)
            .getIn(['translations', langCode, 'name'], 'room');
        }

        if (needAddOccupName) {
          roomTitle += roomOccupName;
        }

        const board = reservationObj
          .get('boards')
          .find(b => +b.get('id') === +boardId)
          .getIn(['translations', langCode]);


        let boardName = 'board';
        if (board && board.get) {
          const corporate = block.get('is_corporate', false);
          boardName = corporate && board.get('corporate_name') ? board.get('corporate_name') : board.get('custom_name_web') ? board.get('custom_name_web') : board.get('name', 'board');
        }

        let roomPrice = showTaxes ? block.get('price_tax') : block.get('price');
        if (block.get('discount_amount')) roomPrice -= block.get('discount_amount');
        const roomPriceBeforeOtherDiscounts = roomPrice;

        const reservationDiscounts = reservationObj.get('discounts', List());
        const blockDiscounts = block.get('discounts', List());
        if (reservationDiscounts && blockDiscounts) {
          reservationDiscounts.forEach(discount => {
            if (!discount.get('is_promotion_code') && !discount.get('is_corporate') && !discount.get('is_loyalty')) {
              if (blockDiscounts.includes(discount.get('id'))) {
                if (discount.get('amount')) roomPrice += discount.get('amount');
                else if (discount.get('discount_amount')) roomPrice += discount.get('discount_amount');
                else if (discount.get('type') === "percent") roomPrice += (summaryPriceBreakdown ? roomPriceBeforeOtherDiscounts : roomPrice) * discount.get('default_value') / 100;
                else roomPrice += discount.get('default_value');
              }
            }
          });
        }

        block.get('services').forEach(service => {
          let serviceId = service.get('service_id', false);
          let serviceInfo = reservationObj
            .get('services')
            .find(s => +s.get('id') === +serviceId);

          let serviceTitle = serviceInfo
            .getIn(['translations', langCode, 'name'], 'service');

          const serviceType = serviceInfo.get('type').toUpperCase();

          let servicePrice =
            (showTaxes ? serviceInfo.get('price_tax') : serviceInfo.get('price')) *
            service.get('quantity');

          if (serviceType === SERVICE_TYPE_PER_PERSON || serviceType === SERVICE_TYPE_PER_PERSON_NIGHT) {
            const roomAvail = reservationObj.getIn([block.get('idx') - 1, block.get('room_id').toString()]);
            if (serviceInfo.get('has_price_per_child', false) === true) {
              let servicePriceChild = (showTaxes ? serviceInfo.get('child_price_tax', 0) : serviceInfo.get('child_price', 0)) *
                service.get('quantity');
              servicePrice = (servicePrice * roomAvail.get('adults')) + (servicePriceChild * roomAvail.get('childs'));
            } else {
              servicePrice = servicePrice * (roomAvail.get('adults') + roomAvail.get('childs'));
            }
          }
          totalPriceServices = totalPriceServices + servicePrice;

          if (parsedServices[serviceId]) {
            parsedServices[serviceId].servicePrice += servicePrice;
            parsedServices[serviceId].quantity++;
          } else {
            parsedServices[serviceId] = {
              serviceId: serviceId,
              serviceName: serviceTitle,
              servicePrice: servicePrice,
              quantity: 1
            };
          }
        });

        totalPriceRooms = totalPriceRooms + roomPrice;

        breakdown.push({
          room: roomTitle,
          board: boardName,
          price: roomPrice,
        });
      });

      // totalPriceRooms = reservationObj && parseFloat(reservationObj.get(showTaxes ? 'total_price_tax' : 'total_price', 0));
    } else {
      totalPriceRooms = reservationTMS && parseFloat(reservationTMS.get('room_amount', 0));
      totalPriceServices = reservationTMS && parseFloat(reservationTMS.get('extra_amount', 0));
    }


    //let totalPrice = totalPriceRooms + totalPriceServices;

    let totalPrice = showTaxes ? reservationObj.get('total_price_tax') : reservationObj.get('total_price');
    if (isTMSRequest) {
      totalPrice = totalPriceRooms + totalPriceServices;
    }

    const totalPriceWithTaxes = reservationObj.get('total_price_tax');
    let totalPriceWithoutTaxes = reservationObj.get('total_price');

    const { classes } = theme.styles;

    let penaltiesText = reservationTMS && reservationTMS.get('cancellation_cost_description', '');

    if (!prepaymentAmount) {
      prepaymentAmount = reservationTMS && reservationTMS.get('amount', 0);
    }


    const groupedRooms = [];
    breakdown && breakdown.forEach((data, idx) => {
      let room = groupedRooms.find(r => r.roomName === data.room && r.boardName === data.board);
      
      if (room) {
        room.amountZ += data.price;
        room.quantity++;
      } else {
        groupedRooms.push({
          roomName: data.room,
          boardName: data.board,
          amount: data.price,
          quantity: 1,
          showAvailPriceAsText: ''
        });
      }
    });

    let payNow = (!newCofSuccess && prepaymentAmount) || 0;
    let payed = (newCofSuccess && prepaymentAmount) || 0;

    const parsedTaxes = !isTMSRequest ? parseTaxes(hotel, reservationObj) : { included: {}, nonIncluded: {} }

    // GLOSARIO.md FCL-003
    const { taxes, additionalFees } = applyMandatoryFeeSplit(parsedTaxes, summaryPriceBreakdown && !isTMSRequest);
    totalPriceWithoutTaxes += additionalFees;

    // isTMSRequest: taxes.nonIncluded es un placeholder {} (no array) - no hay impuestos que sumar en ese caso.
    const nonIncludedTaxes = isTMSRequest ? 0 : round(sumTaxAmounts(taxes.nonIncluded));

    const totalPriceBase = showTaxes ? totalPriceWithTaxes : totalPriceWithoutTaxes;
    const displayedTotalPrice = getDisplayedTotalPrice({ summaryPriceBreakdown, nonIncludedTaxes, priceBase: totalPriceBase, totalPriceWithTaxes, totalPrice });
    // GLOSARIO.md FCL-003 - "pagar en el hotel" debe incluir los impuestos/fee obligatoria no incluidos, igual que en AvailMainSideSummary.jsx
    const hotelPaymentBase = summaryPriceBreakdown ? totalPriceBase + nonIncludedTaxes : totalPrice;

    const payments = buildTMSPayments({
      giftCodeDiscount,
      payed,
      payNow,
      hotelPaymentBase,
      summaryPriceBreakdown,
      displayedTotalPrice,
      newCofSuccess,
      prepaymentAmount,
    });

    const taxesInformationText = getTaxesInformationText(managementGroupID);

    return (
      <>
        <div className={classes.resumeFullContainer}>
          <div className={fullVersion ? theme.computedInnerStyle : classes.resumeFull}>
            <div className={classes.availMainSideSummaryHeader}>
              <AvailMainSideSummaryHeader reservationConfirmed={fullVersion} />
            </div>

            <div className={classes.separator}></div>

            <div className={classes.content}>
              {(
                <>
                  <div className={classes.availMainSideSummaryHotel}>
                    <AvailMainSideSummaryHotel fullVersion={fullVersion} totalAdults={totalAdults} totalChilds={totalChilds}/>
                  </div>

                  <div className={classes.separator}></div>

                    <div>
                      {!isGroup && (
                        <>
                          <div className={classes.availMainSideSummaryReservation}>
                            <AvailMainSideSummaryReservation reservationTMS={reservationTMS} totalAdults={totalAdults} totalChilds={totalChilds}/>
                          </div>

                          <div className={classes.separator}></div>

                          <div className={classes.summaryBookingBox}>
                            <AvailMainSideSummaryRooms totalPriceRooms={totalPriceRooms} groupedRooms={!isTMSRequest ? groupedRooms : null} reservationTMS={isTMSRequest ? reservationTMS : null}/>
                            {reservationTMS && parsedServices.length > 0 && (
                              <AvailMainSideSummaryServices parsedServices={parsedServices} totalPriceServices={totalPriceServices}/>
                            )}

                            {!isGroup && (
                              <>
                                {!!loyaltyDiscount && (
                                  <AvailMainSideSummaryLoyaltyDiscount loyaltyDiscount={loyaltyDiscount} loyaltyUser={loyaltyUser} loyalty={loyalty}/>
                                )}

                                {!!promoCodeDiscount && (
                                  <AvailMainSideSummaryPromoCodeDiscount promoCodeDiscount={promoCodeDiscount} promoCode={promoCode}/>
                                )}

                                {taxes.included.length > 0 && (
                                  <AvailMainSideSummaryTaxes
                                    taxes={taxes.included}
                                    included={true}
                                    summaryPriceBreakdown={summaryPriceBreakdown}
                                  />
                                )}
                              </>
                            )}
                          </div>

                          <div className={classes.separator}></div>
                        </>
                      )}

                      {(!isGroup || payments) && (
                        <>
                          {summaryPriceBreakdown && (
                            <>
                              <div className={classes.summaryBookingBox}>
                                <AvailMainSideSummarySubtotalPrice
                                  totalPrice={totalPriceWithoutTaxes}
                                  text={'_%subtotal%_'}
                                  taxes={taxes.nonIncluded}
                                  included={false}
                                />
                              </div>
                              <div className={classes.separator}></div>
                            </>
                          )}

                          <div className={[classes.availPaymentBox, !!redeemPoints ? classes.removeGap : ''].join(' ')}>
                            {!isGroup &&
                              <>
                                <AvailMainSideSummaryTotalPrice
                                  totalPrice={displayedTotalPrice}
                                  text={summaryPriceBreakdown || showTaxes && !(isUsDomain() && taxes.nonIncluded.length > 0) ? '_%precio total%_' : '_%precio subtotal%_'}
                                />

                                {!!redeemPoints && (
                                  <AvailMainSideSummaryRedeemPoints redeemPoints={redeemPoints}/>
                                )}

                                {!!giftCodeDiscount && <AvailMainSideSummaryGiftCodeDiscount giftCode={giftCode} giftCodeDiscount={giftCodeDiscount}/>}
                              </>
                            }

                            {payments && payments.map((pay,key) => (
                              <div key={key}>
                                <AvailMainSideSummaryPay redeemPoints={redeemPoints} text={pay.text} value={pay.amount} isEquivalent={pay.isEquivalent} />
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                </>
              )}

              {!!accumulatePoints && (
                <>
                  <div className={classes.separator}></div>

                  <div className={[classes.availMainSideSummaryLoyaltyPoints].join(' ')}>
                    <AvailMainSideSummaryLoyaltyPoints accumulatePoints={accumulatePoints} loyalty={loyalty} />
                  </div>
                </>
              )}

              {(taxes.nonIncluded.length > 0 || !!hotelInfo.get('city_tax')) && !(summaryPriceBreakdown && !hotelInfo.get('city_tax')) &&
                <>
                  <div className={classes.separator}></div>
                  <div className={classes.availMainSideSummaryTaxes}>
                    <AvailMainSideSummaryTaxes
                      taxes={taxes.nonIncluded}
                      included={false}
                      title={((['customerForm', 'confirmation'].includes(stepCode) && taxes.nonIncluded.length > 0) || !!hotelInfo.get('city_tax')) ? taxesInformationText : null}
                      cityTax={hotelInfo.get('city_tax')}
                      summaryPriceBreakdown={summaryPriceBreakdown}
                    />
                  </div>
                </>
              }

              {(penaltiesText.length > 0 || !!penalties) &&
                <div className={[classes.availMainSideSummaryPenalties, fromPayLink ? classes.removePadding : ''].join(' ')}>
                  <AvailMainSideSummaryPenalties text={penaltiesText} penalties={penalties} />
                </div>
              }

              {managementGroupID === PROPERTY_MANAGEMENT_GROUP && (
                <div className={classes.availMainSideSummaryHotelInfo}>
                  <AvailMainSideSummaryHotelInfo/>
                </div>
              )}
              
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = dispatch => {
    return {};
  };

const mapStateToProps = (store, ownProps) => {
    const fromTMS = store.getIn(['customer', 'params', 'url_params', 'from_tms'], false) === 'true';
    const hotelId = store.getIn(['customer', 'current_hotel']);
    const hotelInfo = store.getIn(['hotels', hotelId]);
    const reservationObj = store.getIn(['customer', 'reservation'], false) || store.getIn(['customer', 'reservation', 'tms_reservation'], false);
    let reservationTMS = reservationObj && (reservationObj.get('tms_reservation', false) || reservationObj);
    const isTMSRequest = store.getIn(['customer', 'params', 'url_params', 'from_tms'], false) === 'true' && reservationObj.get('status_id',false);
    const hotel = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;
    const tmsTracking = store.getIn(['customer', 'params', 'url_params', 'tms_tracking'], false);
    const fromPayLink = store.getIn(['customer', 'params', 'url_params', 'from_paylink'], false) === 'true';
    const stepCode = store.getIn(['customer', 'step', 'current_step', 'code']);

    if(tmsTracking && reservationTMS && !fromTMS) {
      reservationTMS = reservationTMS.find(
        r => r.get('tracking_id') === parseInt(tmsTracking, 10)
      );
    }
    let adults = 0, 
        childs = 0;
    const occupGroups = [];
    if(!isTMSRequest) {
      const reservationBlocks = reservationObj && reservationObj.get('blocks');
      reservationBlocks.forEach(block => {
        occupGroups.push(block.get('occup_group_id',false));
      });
      const reservationOccups = reservationObj && reservationObj.get('occup_groups');
      occupGroups.forEach(occupGroup => {
        let occup = reservationOccups.find(d => (d.get('id', '') || '') === occupGroup || false);
        let occupancies = occup && occup.get('occupancies');
        occupancies.forEach((occ) => {
          if(occ.get('code') === '10') {
            adults += occ.get('count',0);
          } else {
            childs += occ.get('count',0);
          }
        });
      });
    } else {
      adults = reservationTMS && reservationTMS.get('adults', 0);
      childs = reservationTMS && reservationTMS.get('childs', 0);
    }



  const amountPromoPaid = reservationObj.getIn(['payment', 'amount_promo_paid'], 0);
    let giftCode = null;
    let giftCodeDiscount = 0;

    if (amountPromoPaid > 0 && reservationObj.getIn(['gift_voucher', 'code'], '') !== '') {
    giftCodeDiscount = amountPromoPaid * -1;
    giftCode = reservationObj.getIn(['gift_voucher', 'code']);
  }

  let promoCodeDiscount = 0;
  let promoCode = (reservationObj && reservationObj.getIn(['promotion', 'code'], false)) || store.getIn(['customer', 'params', 'url_params','promotion_code'], false);

  reservationObj && reservationObj.get('blocks') && reservationObj.get('blocks').forEach(block => {
    let computedDiscountValue = 0;
    block && block.get('days').forEach(day => {
    const findDiscount = day.get('discounts', List()).find(discount => {
      return discount.get('is_promotion_code');
    });
    let discountValue = 0;

    if (findDiscount) {
      const baseDiscountValue = Math.abs(findDiscount.get('amount', 0));
      if (!day.get('taxes_included') && hotel.get('show_taxes')) {
      discountValue = baseDiscountValue + (baseDiscountValue * day.get('tax_percent')) / 100;
      } else if (day.get('taxes_included') && !hotel.get('show_taxes')) {
        discountValue = baseDiscountValue / (day.get('tax_percent') / 100 + 1);
      } else {
        discountValue = findDiscount.get('amount', 0);
      }
    }
    computedDiscountValue += discountValue || 0;
  }, 0);
    promoCodeDiscount += computedDiscountValue;
  })

  let loyaltyDiscount = 0
  reservationObj && reservationObj.get('blocks') && reservationObj.get('blocks').forEach(block => {
    let computedDiscountValue = 0;
    block && block.get('days').forEach(day => {
      const findDiscount = day.get('discounts', List()).find(discount => {
        return discount.get('is_loyalty');
      });
      let discountValue = 0;

      if (findDiscount) {
        const baseDiscountValue = Math.abs(findDiscount.get('amount', 0));
        if (!day.get('taxes_included') && hotel.get('show_taxes')) {
          discountValue = baseDiscountValue + (baseDiscountValue * day.get('tax_percent')) / 100;
        } else if (day.get('taxes_included') && !hotel.get('show_taxes')) {
          discountValue = baseDiscountValue / (day.get('tax_percent') / 100 + 1);
        } else {
          discountValue = findDiscount.get('amount', 0);
        }
      }
      computedDiscountValue += discountValue || 0;
    }, 0);
    loyaltyDiscount += computedDiscountValue;
  })
  
  const accumulatePoints = store.getIn(['customer', 'reservation',"loyalty", "accumulated_points"], false);
  let penalties = null;
  const managementGroupID = is(Map, hotel) && hotel.size > 0 && hotel.get('name') && hotel.get('management_group_id');
  const rateSecureCancellation = reservationObj && reservationObj?.get('rates')?.some(d => d?.get('secure_cancellation', false));
  const discountSecureCancellation = reservationObj && reservationObj?.get('discounts')?.some(d => d?.get('secure_cancellation', false));
  const serviceSecureCancellation = reservationObj && reservationObj?.get('services')?.some(d => d?.get('secure_cancellation', false));
  const pmsName = hotelInfo && hotelInfo.get('pms');
  const pms = ((rateSecureCancellation || discountSecureCancellation || serviceSecureCancellation) && pmsName === 'FlexMyRoom') ? 'FlexMyRoom' : false;

  if (fromPayLink && reservationObj) {
    penalties = getPenalties(reservationObj, managementGroupID === PROPERTY_MANAGEMENT_GROUP, pms, null, managementGroupID, getPenaltyTimezone(hotelInfo), getPenaltyChargebackUSA(hotelInfo));
  }

  const redeemPoints  = reservationObj.getIn(["loyalty", "redeem_points"], 0);

  return {
    reservationObj: reservationObj.size ? reservationObj : undefined,
    reservationTMS: reservationTMS, // USED
    hotel: hotel,
    totalAdults: adults, // USED
    totalChilds: childs, // USED
    newCofSuccess: ownProps.newCofSuccess || false,
    isGroup: ownProps.isGroup || false,
    isTMSRequest : isTMSRequest,
    prepaymentAmount : ownProps.prepaymentAmount,
    loyaltyUser: store.getIn(['customer', 'loyalty','user'], null),
    loyalty: store.getIn(['customer', 'loyalty', 'data','loyalty'], null),
    loyaltyDiscount,
    giftCodeDiscount,
    giftCode,
    promoCodeDiscount,
    promoCode,
    tmsTracking: tmsTracking,
    accumulatePoints,
    fromPayLink: fromPayLink,
    penalties: penalties,
    redeemPoints,
    summaryPriceBreakdown: hotel && hotel.get('summary_price_breakdown', false),
    stepCode,
    hotelInfo,
    managementGroupID: is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo.get('management_group_id'),
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, []),
  connect(
  mapStateToProps,
  mapDispatchToProps
  ),
  PropertyManager([
    'reservationObj',
    'reservationTMS',
    'newCofSuccess',
    'hotel',
    'totalAdults',
    'totalChilds',
    'isGroup',
    'fullVersion',
    'isTMSRequest',
    'prepaymentAmount',
    'loyaltyDiscount',
    'loyaltyUser',
    'loyalty',
    'giftCodeDiscount',
    'giftCode',
    'promoCodeDiscount',
    'promoCode',
    'tmsTracking',
    'accumulatePoints',
    'fromPayLink',
    'penalties',
    'redeemPoints',
    'summaryPriceBreakdown',
    'stepCode',
    'hotelInfo',
    'managementGroupID'
  ]),
  withThemeJSS({styleFile, link: true}),
  withContent('i18n')
)(AvailMainSideSummary);
